<template>
  <div>
    <v-alert outlined color="info" text class="mb-5" v-if="false">
      We correspond through email. Please make sure you enter a valid email and
      then check it for updates regarding your application
    </v-alert>
    <v-form ref="form" v-model="valid">
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field
            outlined
            v-model="form.firstName"
            :rules="rules"
            label="First Name"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            outlined
            v-model="form.middleName"
            label="Middle Name"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            outlined
            v-model="form.lastName"
            :rules="rules"
            label="Last Name"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.email"
            outlined
            :rules="emailRules"
            label="Email"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.phone"
            :rules="mobileRules"
            type="number"
            label="Phone"
            outlined
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="form.dob"
                outlined
                :rules="date"
                label="Date of Birth"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              :show-current="max"
              v-model="form.dob"
              :max="max"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.social_security_number"
            type="number"
            label="Social Security Number"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <CoSigner v-model="coSigner" />

    <v-btn @click="$emit('step', 1)" class="mr-5" color="primary">Back</v-btn>
    <v-btn color="green" dark @click="submit()">Continue</v-btn>
  </div>
</template>

<script>
import CoSigner from "./CoSigner";
export default {
  components: {
    CoSigner,
  },
  data() {
    return {
      form: {
        middleName: "",
        phone: "",
        dob: "",
        lastName: "",
        email: "",
        social_security_number: "",
        firstName: "",
      },
      mobileRules: [
        (v) => !!v || "Field is required",
        (v) => (!!v && v.length <= 10) || "Phone can't be more then 10 digit",
      ],

      coSigner: [],
      valid: false,
      max: new Date().toISOString().substr(0, 10),
      menu: false,
      rules: [(v) => !!v || "Field is required"],
      emailRules: [
        (v) => !!v || "Field is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      date: [
        (v) => !!v || "Date of birth is required",
        (v) => this.getAge(v) >= 18 || "Age must be above 18",
      ],
    };
  },
  methods: {
    getAge(birthDateString) {
      var today = new Date();
      var birthDate = new Date(birthDateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    submit() {
      const vm = this;
      vm.$refs.form.validate();
      let form = vm.$store.getters.form;
      form.personalInfo = vm.form;
      form.coSigner = vm.coSigner;
      vm.$store.commit("setForm", form);
      if (!vm.valid) return;
      vm.$emit("step", 3);
    },
  },
  mounted() {
    const vm = this;
    let form = vm.$store.getters.form;
    form.personalInfo = vm.form;
    form.coSigner = vm.coSigner;
    vm.$store.commit("setForm", form);
  },
};
</script>

<style></style>
